const attendingStatus = {
  NOT_STARTED: 'Não Iniciado',
  STARTED: 'Iniciado',
  INTERRUPTED: 'Interrompido',
  WAITING_CENTRAL_VALIDATION: 'Aguardando Validação da Central',
  FINISHED: 'Atendimento Finalizado',
  ATTENDING_COMPLETED: 'Instalação Realizada'
};

export default attendingStatus;



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/attending-status.ts